import React from 'react'

const GroupsToDosIcon = (
  <>
    <path
      d="M16.6666 4.33398H8.66659C8.48225 4.33398 8.33325 4.48298 8.33325 4.66732C8.33325 4.85165 8.48225 5.00065 8.66659 5.00065H16.6666C16.8509 5.00065 16.9999 4.85165 16.9999 4.66732C16.9999 4.48298 16.8509 4.33398 16.6666 4.33398Z"
      fill="#335262"
    />
    <path
      d="M16.6666 9.66602H8.66659C8.48225 9.66602 8.33325 9.81502 8.33325 9.99935C8.33325 10.1837 8.48225 10.3327 8.66659 10.3327H16.6666C16.8509 10.3327 16.9999 10.1837 16.9999 9.99935C16.9999 9.81502 16.8509 9.66602 16.6666 9.66602Z"
      fill="#335262"
    />
    <path
      d="M16.6666 15H8.66659C8.48225 15 8.33325 15.149 8.33325 15.3333C8.33325 15.5177 8.48225 15.6667 8.66659 15.6667H16.6666C16.8509 15.6667 16.9999 15.5177 16.9999 15.3333C16.9999 15.149 16.8509 15 16.6666 15Z"
      fill="#335262"
    />
    <path
      d="M6 3H3.33333C3.149 3 3 3.149 3 3.33333V6C3 6.18433 3.149 6.33333 3.33333 6.33333H6C6.18433 6.33333 6.33333 6.18433 6.33333 6V3.33333C6.33333 3.149 6.18433 3 6 3Z"
      fill="#1890FF"
    />
    <path
      d="M6 8.33398H3.33333C3.149 8.33398 3 8.48298 3 8.66732V11.334C3 11.5183 3.149 11.6673 3.33333 11.6673H6C6.18433 11.6673 6.33333 11.5183 6.33333 11.334V8.66732C6.33333 8.48298 6.18433 8.33398 6 8.33398Z"
      fill="#1890FF"
    />
    <path
      d="M6 13.666H3.33333C3.149 13.666 3 13.815 3 13.9993V16.666C3 16.8503 3.149 16.9993 3.33333 16.9993H6C6.18433 16.9993 6.33333 16.8503 6.33333 16.666V13.9993C6.33333 13.815 6.18433 13.666 6 13.666Z"
      fill="#1890FF"
    />
  </>
)

export default GroupsToDosIcon
